import { defineMessages } from "react-intl";

export const scope = "loyaltyApp";

export default defineMessages({
  homeGreeting: {
    id: `${scope}.homeGreeting`,
    defaultMessage: "Hi, {name}!",
  },
  homeMessage: {
    id: `${scope}.homeMessage`,
    defaultMessage: "How are you today?",
  },
  homeLabel: {
    id: `${scope}.homeLabel`,
    defaultMessage: "Home",
  },
  appointmentsLabel: {
    id: `${scope}.appointmentsLabel`,
    defaultMessage: "Appointments",
  },
  recordsLabel: {
    id: `${scope}.recordsLabel`,
    defaultMessage: "Perks",
  },
  profileLabel: {
    id: `${scope}.profileLabel`,
    defaultMessage: "My Profile",
  },
  infoLabel: {
    id: `${scope}.infoLabel`,
    defaultMessage: "Info",
  },
  membershipLevelsLabel: {
    id: `${scope}.loyaltyTiersLabel`,
    defaultMessage: "Loyalty",
  },
  rewardsCatalogLabel: {
    id: `${scope}.rewardsCatalogLabel`,
    defaultMessage: "Vouchers",
  },
  levelSubtitel: {
    id: "levelSubtitel",
    defaultMessage: "Level {level}",
  },
  noLevelsFound: {
    id: `${scope}.noLevelsFound`,
    defaultMessage: "No Active Tiers",
  },
  noLevelsFoundDescription: {
    id: `${scope}.noLevelsFoundDescription`,
    defaultMessage:
      "Join a loyalty tier to start earning rewards and unlock exclusive perks.",
  },
  noRewardsFound: {
    id: `${scope}.noRewardsFound`,
    defaultMessage: "No Vouchers Available",
  },
  noRewardsFoundDescription: {
    id: `${scope}.noRewardsFoundDescription`,
    defaultMessage:
      "Redeem your points for vouchers and enjoy special discounts and offers.",
  },
  redeemVoucher: {
    id: `${scope}.redeemVoucher`,
    defaultMessage: "Redeem Voucher",
  },
  redeemVoucherDescription: {
    id: `${scope}.redeemVoucherDescription`,
    defaultMessage:
      "Once you confirm, this voucher will be yours and points will be deducted. Are you sure you want to continue?",
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: "Cancel",
  },
  confirm: {
    id: `${scope}.confirm`,
    defaultMessage: "Yes, Redeem",
  },
  redeemVoucherSuccess: {
    id: `${scope}.redeemVoucherSuccess`,
    defaultMessage: "Voucher redeemed successfully.",
  },
  membershipsLabel: {
    id: `${scope}.membershipsLabel`,
    defaultMessage: "Memberships",
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: "Search",
  },
  currentPointsBalance: {
    id: `${scope}.currentPointsBalance`,
    defaultMessage: "Current Point Balance:",
  },
  notEnoughPoints: {
    id: `${scope}.notEnoughPoints`,
    defaultMessage: "Spend {amount} to get this award",
  },
  availableAt: {
    id: `${scope}.availableAt`,
    defaultMessage: "Available at: {date}",
  },
});
